export enum ProductStatus {
  Open = 1,
  Closed,
  DailyClosed,
  Invisible,
}
